/** Communications permissions, matched to the guards in `src/clubcore/communications/api.py`. */

/** The log, unknown callers, a member's timeline and every phone message. */
export const COMMS_READ = "comms.read";
/** Link a call or number to a member and change any phone message. */
export const COMMS_WRITE = "comms.write";
/** Take a phone message and handle the ones addressed to you or your role. */
export const COMMS_MESSAGES = "comms.messages";
/** Choose the country phone numbers are read in. */
export const COMMS_SETTINGS = "comms.settings";
